import { createProxyClient } from '../api/createProxyClient';

/**
 * ebill-API-Client (E-Rechnung). Immer ueber den BFF-Proxy `/proxy/ebill/...`.
 * Der BFF injiziert server-seitig das GATEWAY_SHARED_SECRET (ebill hat
 * gateway-guard). Kein Operator-Bearer noetig.
 *
 * Nutzt jetzt die gemeinsame createProxyClient-Fabrik (#116) — Signatur/Verhalten
 * unveraendert.
 */
const client = createProxyClient('ebill');

export const ebillFetch = client.fetch;
export const isEbillProxyEnabled = client.isEnabled;

/** Absoluter Proxy-Pfad fuer Downloads (Artefakt-PDF ueber den BFF). */
export function ebillDownloadUrl(id) {
  return client.proxyUrl(`v1/download/${encodeURIComponent(id)}`);
}
